module.exports = __webpack_public_path__ + "img/getImage-1.0815f1ce.jpeg";